// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"RegisterForm_formGroup__2tJ4C","label":"RegisterForm_label__5wUrE"};